import { useState, useEffect, useLayoutEffect, useRef } from 'react'

function useViewportSizes() {
  const refParentElement = useRef(null)

  const [dimensions, setDimensions] = useState({
    width: window.innerWidth || 0,
    height: window.innerHeight || 0
  })

  // Find element root(#gofind-finder)
  useLayoutEffect(() => {
    const parentElementGofind = document.getElementById('gofind-finder')

    if (parentElementGofind) refParentElement.current = parentElementGofind
  }, [])

  // Set dimensions element root(#gofind-finder) adapting viewport app
  useLayoutEffect(() => {
    if (refParentElement.current) {
      setDimensions({
        width: refParentElement.current.clientWidth,
        height: refParentElement.current.clientHeight
      })

      // Inject properties css default
      refParentElement.current.style.position = 'relative'
      refParentElement.current.style.width = '100%'
      refParentElement.current.style.height = '100%'
    }
  }, [])

  const resizeDimensions = () => {
    setDimensions({
      width: refParentElement.current?.clientWidth || window.innerWidth,
      height: refParentElement.current?.clientHeight || window.innerHeight
    })
  }

  useEffect(() => {
    window.addEventListener('resize', resizeDimensions)

    return () => {
      window.removeEventListener('resize', resizeDimensions)
    }
  }, [dimensions])

  return dimensions
}

export default useViewportSizes
